import { defineMessages } from 'react-intl';

/** The copy of the live campaign page (design outreach-v2 g1, g4): the head, the tabs, Today and the side cards. */
export const campaignPageMessages = defineMessages({
  // head
  eyebrowPitching: { id: 'app.outreach.campaignPage.eyebrow.pitching', defaultMessage: 'Plug is pitching' },
  eyebrowPaused: { id: 'app.outreach.campaignPage.eyebrow.paused', defaultMessage: 'Paused' },
  eyebrowDone: { id: 'app.outreach.campaignPage.eyebrow.done', defaultMessage: 'Ended' },
  subRate: { id: 'app.outreach.campaignPage.sub.rate', defaultMessage: '{count} a day' },
  subFrom: { id: 'app.outreach.campaignPage.sub.from', defaultMessage: 'from {mailbox}' },
  subUntil: { id: 'app.outreach.campaignPage.sub.until', defaultMessage: 'until {date}' },
  subUntilStopped: { id: 'app.outreach.campaignPage.sub.untilStopped', defaultMessage: 'until you stop it' },
  editSetup: { id: 'app.outreach.campaignPage.editSetup', defaultMessage: 'Edit setup' },
  pause: { id: 'app.outreach.campaignPage.pause', defaultMessage: 'Pause' },
  resume: { id: 'app.outreach.campaignPage.resume', defaultMessage: 'Resume' },
  delete: { id: 'app.outreach.campaignPage.delete', defaultMessage: 'Delete' },
  deleteConfirm: {
    id: 'app.outreach.campaignPage.deleteConfirm',
    defaultMessage: 'Delete this campaign? Pitches that wait do not go out. Sent pitches and replies stay.',
  },
  tabToday: { id: 'app.outreach.campaignPage.tab.today', defaultMessage: 'Today' },
  tabPeople: { id: 'app.outreach.campaignPage.tab.people', defaultMessage: 'People' },
  tabResults: { id: 'app.outreach.campaignPage.tab.results', defaultMessage: 'Results' },
  tabsLabel: { id: 'app.outreach.campaignPage.tabs', defaultMessage: 'Campaign views' },

  // today card (ring)
  todayDate: { id: 'app.outreach.campaignPage.today.date', defaultMessage: 'Today, {date}' },
  ringLabel: {
    id: 'app.outreach.campaignPage.today.ring',
    defaultMessage: '{sent} of {rate} pitches out today',
  },
  todayTitle: {
    id: 'app.outreach.campaignPage.today.title',
    defaultMessage: '{sent} pitched, {left} go out by {time}',
  },
  todayTitleNoTime: {
    id: 'app.outreach.campaignPage.today.titleNoTime',
    defaultMessage: '{sent} pitched, {left} wait to go out',
  },
  todayTitleAllOut: {
    id: 'app.outreach.campaignPage.today.titleAllOut',
    defaultMessage: '{count, plural, one {# pitch} other {# pitches}} out today',
  },
  todayTitlePaused: {
    id: 'app.outreach.campaignPage.today.titlePaused',
    defaultMessage: 'Plug sends nothing while paused',
  },
  todayTitleDone: { id: 'app.outreach.campaignPage.today.titleDone', defaultMessage: 'This campaign ended' },
  nextTheirTime: {
    id: 'app.outreach.campaignPage.today.nextTheirTime',
    defaultMessage: 'Next: {place} at {time} their time.',
  },
  nextYourTime: { id: 'app.outreach.campaignPage.today.nextYourTime', defaultMessage: 'Next at {time}.' },
  nextSomeone: { id: 'app.outreach.campaignPage.today.nextSomeone', defaultMessage: 'someone in {place}' },
  newFits: {
    id: 'app.outreach.campaignPage.today.newFits',
    defaultMessage: 'Plug found {count, plural, one {# new person} other {# new people}} who fit {song} last night.',
  },
  newFitsSoFar: {
    id: 'app.outreach.campaignPage.today.newFitsSoFar',
    defaultMessage: 'Plug found {count, plural, one {# person} other {# people}} who fit {song} so far.',
  },
  tomorrow: {
    id: 'app.outreach.campaignPage.today.tomorrow',
    defaultMessage: 'Tomorrow Plug picks {count} more.',
  },
  labelOffer: { id: 'app.outreach.campaignPage.today.labelOffer', defaultMessage: 'Pitch 15 a day on Ultra' },
  labelOfferSub: { id: 'app.outreach.campaignPage.today.labelOfferSub', defaultMessage: '3x the people, autopilot' },
  reviewWaiting: {
    id: 'app.outreach.campaignPage.today.reviewWaiting',
    defaultMessage: '{count, plural, one {# pitch waits} other {# pitches wait}} for you',
  },
  reviewWaitingSub: {
    id: 'app.outreach.campaignPage.today.reviewWaitingSub',
    defaultMessage: 'Approve them and they go in each person’s morning.',
  },
  reviewOpen: { id: 'app.outreach.campaignPage.today.reviewOpen', defaultMessage: 'Read today’s pitches' },

  // stats
  statPitched: { id: 'app.outreach.campaignPage.stat.pitched', defaultMessage: 'Pitched' },
  statOpened: { id: 'app.outreach.campaignPage.stat.opened', defaultMessage: 'Opened the song' },
  statListened: { id: 'app.outreach.campaignPage.stat.listened', defaultMessage: 'Listened 30 s+' },
  statReplied: { id: 'app.outreach.campaignPage.stat.replied', defaultMessage: 'Replied' },
  statAdded: { id: 'app.outreach.campaignPage.stat.added', defaultMessage: 'Added the song' },
  statToday: { id: 'app.outreach.campaignPage.stat.today', defaultMessage: '+{count} today' },
  statPercent: { id: 'app.outreach.campaignPage.stat.percent', defaultMessage: '{percent}%' },

  // found last night
  foundTitle: { id: 'app.outreach.campaignPage.found.title', defaultMessage: 'Found last night' },
  foundTitleSoFar: { id: 'app.outreach.campaignPage.found.titleSoFar', defaultMessage: 'Found so far' },
  foundMeta: { id: 'app.outreach.campaignPage.found.meta', defaultMessage: '{count} new' },
  foundMetaSoFar: { id: 'app.outreach.campaignPage.found.metaSoFar', defaultMessage: '{count} found' },
  foundNone: {
    id: 'app.outreach.campaignPage.found.none',
    defaultMessage: 'No new person last night. Plug looks again tonight.',
  },
  foundNoneSoFar: {
    id: 'app.outreach.campaignPage.found.noneSoFar',
    defaultMessage: 'No one yet. Plug looks again tonight.',
  },
  waiting: { id: 'app.outreach.campaignPage.found.waiting', defaultMessage: 'Good fits waiting' },
  lasts: { id: 'app.outreach.campaignPage.found.lasts', defaultMessage: 'At {rate} a day that lasts' },
  lastsDays: {
    id: 'app.outreach.campaignPage.found.lastsDays',
    defaultMessage: '{count, plural, one {# day} other {# days}}',
  },
  lastsPast: { id: 'app.outreach.campaignPage.found.lastsPast', defaultMessage: 'past {date}' },
  lastsLessThanDay: { id: 'app.outreach.campaignPage.found.lastsLessThanDay', defaultMessage: 'less than a day' },

  // mailbox
  mailboxTitle: { id: 'app.outreach.campaignPage.mailbox.title', defaultMessage: 'Mailbox' },
  mailboxWarming: { id: 'app.outreach.campaignPage.mailbox.warming', defaultMessage: 'Warming up' },
  mailboxReady: { id: 'app.outreach.campaignPage.mailbox.ready', defaultMessage: 'Ready' },
  mailboxLine: {
    id: 'app.outreach.campaignPage.mailbox.line',
    defaultMessage: '{mailbox} · day {day} of {total}.',
  },
  mailboxFits: {
    id: 'app.outreach.campaignPage.mailbox.fits',
    defaultMessage: 'Your {rate} a day fits from today.',
  },
  mailboxNotYet: {
    id: 'app.outreach.campaignPage.mailbox.notYet',
    defaultMessage: 'It sends {cap} a day now. Plug sends the rest of your {rate} a day when the mailbox is warm.',
  },
  mailboxWarm: {
    id: 'app.outreach.campaignPage.mailbox.warm',
    defaultMessage: '{mailbox} is warm. It sends your full rate.',
  },
  mailboxNone: { id: 'app.outreach.campaignPage.mailbox.none', defaultMessage: 'No mailbox sends for this campaign.' },

  // never contact
  neverTitle: { id: 'app.outreach.campaignPage.never.title', defaultMessage: 'Never contact' },
  neverNone: {
    id: 'app.outreach.campaignPage.never.none',
    defaultMessage: 'Nobody yet. Block a person on a row and Plug never pitches them again.',
  },
  neverMore: { id: 'app.outreach.campaignPage.never.more', defaultMessage: '+ {count} more' },
  neverRemove: { id: 'app.outreach.campaignPage.never.remove', defaultMessage: 'Remove {label}' },
  blockKindEmail: { id: 'app.outreach.campaignPage.never.kind.email', defaultMessage: 'Email' },
  blockKindDomain: { id: 'app.outreach.campaignPage.never.kind.domain', defaultMessage: 'Website' },
  blockKindPlaylist: { id: 'app.outreach.campaignPage.never.kind.playlist', defaultMessage: 'Playlist' },
  blockKindContact: { id: 'app.outreach.campaignPage.never.kind.contact', defaultMessage: 'Person' },

  // spotify editorial
  editorialTitle: { id: 'app.outreach.campaignPage.editorial.title', defaultMessage: 'Spotify editorial' },
  editorialBody: {
    id: 'app.outreach.campaignPage.editorial.body',
    defaultMessage:
      "Plug cannot pitch Spotify's own playlists. Pitch them yourself in Spotify for Artists before {date}.",
  },
  editorialBodyNoDate: {
    id: 'app.outreach.campaignPage.editorial.bodyNoDate',
    defaultMessage: "Plug cannot pitch Spotify's own playlists. Pitch them yourself in Spotify for Artists.",
  },
  editorialOpen: { id: 'app.outreach.campaignPage.editorial.open', defaultMessage: 'Open the pitch helper' },
});
